export default __webpack_public_path__ + "static/media/logo_audited.5db15adf.png";